import React from 'react';
import {Box, Typography} from '@mui/material';
import {ErrorOutline} from '@mui/icons-material';
import theme from '../../../theme/Theme';

interface RecommendParserStepProps {
  errorText: string;
}

function RecommendParserStep(props: RecommendParserStepProps) {
  const {errorText} = props;

  return (
    <div
      style={{
        marginTop: theme.spacing(3),
        width: '100%',
        textAlign: 'center',
      }}
    >
      {errorText ? (
        <Box display="flex" justifyContent="center" mb={4} mt={4} alignContent="center">
          <ErrorOutline color="error" />
          <Typography style={{marginLeft: 10}} color="error">
            {errorText}
          </Typography>
        </Box>
      ) : null}
    </div>
  );
}

export default RecommendParserStep;
